import React from 'react';
import { Grid, Typography } from '@mui/material';

function HeaderCancilleria() {
    return (
        <>
            <div className="cont headercancilleria">
                <Grid container boxShadow={4} padding=".4rem 1rem">
                    <Grid
                        margin="0 auto"
                        maxWidth="1100px"
                        width="100%"
                        display="flex"
                        alignItems="center"
                    >
                        <Grid item>
                            <a
                                className="logo custom-logo align-items-center"
                                href="https://www.cancilleria.gov.co/"
                            >
                                <img
                                    alt="Cancilleria"
                                    className="my-3 logo-colombia"
                                    height="60"
                                />
                            </a>
                        </Grid>
                        <Grid item className="title-header">
                            <Typography>PQRSDF</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default HeaderCancilleria;
